import { setCookies } from "utils/CookiesUtil";
import { makeApiCall } from "utils/ApiWrapperUtil";
import API_URL_CONSTANTS from "../../Constants/ApiUrlConstants";
import { DASHBOARD_PATH } from "../../Route/PathConstants";
import {
  SHOW_LOGIN_LOADER,
  SET_LOGIN_ERROR,
  SET_LOGIN_SUCCESS,
} from "../../Constants/ActionConstants";

export const emitEventToReducer = (params) => ({
  type: params.type,
  payload: params.payload,
});

export const loginAction = (params) => async (dispatch) => {
  try {
    if (params.email) {
      dispatch(
        emitEventToReducer({
          type: SHOW_LOGIN_LOADER,
          payload: true,
        }),
      );
      const loginResponse = await makeApiCall({
        url: API_URL_CONSTANTS.SIGNIN,
        method: "post",
        request: {
          emailAddress: params.email,
          password: params.password,
        },
      });

      if (loginResponse.status === 200) {
        dispatch(
          emitEventToReducer({
            type: SET_LOGIN_SUCCESS,
            payload: loginResponse.data,
          }),
        );

        if (loginResponse.headers.auth) {
          setCookies("AUTH_TOKEN", loginResponse.headers.auth);
        }
        window.location.href = DASHBOARD_PATH;
      } else {
        dispatch(
          emitEventToReducer({
            type: SET_LOGIN_ERROR,
            payload: { msg: "Invalid User" },
          }),
        );
      }
    } else {
      dispatch(
        emitEventToReducer({
          type: SET_LOGIN_ERROR,
          payload: { msg: "Email is not valid" },
        }),
      );
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

// eslint-disable-next-line no-unused-vars

export const SignUpAction = (params) => async (dispatch) => {
  try {
    if (params.email) {
      dispatch(
        emitEventToReducer({
          type: SHOW_LOGIN_LOADER,
          payload: true,
        }),
      );
      const loginResponse = await makeApiCall({
        url: API_URL_CONSTANTS.SINGUP,
        method: "post",
        request: {
          name: params.name,
          emailAddress: params.email,
          mobileNumber: params.mobile,
          countryId: 1,
          role: 1,
          password: "Test@123",
        },
      });

      if (loginResponse.status === 200) {
        dispatch(
          emitEventToReducer({
            type: SET_LOGIN_SUCCESS,
            payload: loginResponse.data,
          }),
        );

        window.location.href = DASHBOARD_PATH;
      } else {
        dispatch(
          emitEventToReducer({
            type: SET_LOGIN_ERROR,
            payload: { msg: "Invalid User" },
          }),
        );
      }
    } else {
      dispatch(
        emitEventToReducer({
          type: SET_LOGIN_ERROR,
          payload: { msg: "Email is not valid" },
        }),
      );
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

// eslint-disable-next-line no-unused-vars
